import ErrorOutlined from '@mui/icons-material/ErrorOutlined'
import React from 'react'
import { ErrorStateProps } from './types'

export const ErrorState: React.FC<ErrorStateProps> = () => (
  <div className="flex flex-col items-center justify-center py-16">
    <div className="mb-4 flex items-center rounded-lg bg-error-light/40 px-2 py-1">
      <div className="mr-1 flex h-6 w-3 items-center justify-center">
        <ErrorOutlined sx={{ fontSize: 14 }} className="text-error" />
      </div>

      <span className="font-semibold text-red-700">
        Error: Failed to load data.
      </span>
    </div>

    <p className="text-sm text-gray-600">
      Please try again, or refresh the page if the issue persists.
    </p>
  </div>
)
